// redux/slices/couponSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  couponApplied: false,
  couponCode: "",
  couponDiscountType: "", // e.g., "percentage" or "fixed"
  couponDiscountValue: 0, // e.g., 10 for 10% or ₹100
  couponDiscountAmount: 0, // calculated discount amount (e.g., ₹50)
  priceAfterCouponDiscount: 0, // final price after discount
  bookingTotalAmount: 0, // original price before discount
};

const couponSlice = createSlice({
  name: "coupon",
  initialState,
  reducers: {
    setCouponData: (state, action) => {
      state.couponApplied = action.payload.couponApplied ?? false;
      state.couponCode = action.payload.couponCode ?? "";
      state.couponDiscountType = action.payload.couponDiscountType ?? "";
      state.couponDiscountValue = action.payload.couponDiscountValue ?? 0;
      state.couponDiscountAmount = action.payload.couponDiscountAmount ?? 0;
      state.priceAfterCouponDiscount =
        action.payload.priceAfterCouponDiscount ?? 0;
      state.bookingTotalAmount = action.payload.bookingTotalAmount ?? 0;
    },
    removeCoupon: (state) => {
      // Reset to initial state
      Object.assign(state, initialState);
    },
  },
});

export const { setCouponData, removeCoupon } = couponSlice.actions;
export default couponSlice.reducer;
